export default __webpack_public_path__ + "static/media/benefits_2.abaa375c.webp";